import config from '@/config';

/**
 * Get the extension from a filename
 * @param {String} str
 */
export const getExtension = str => {
    return str.split('.').pop().split('?').shift();
};

/**
 * Remove the extension from a filename
 * @param {String} str
 */
export const removeExtension = str => {
    return str.split('.').shift();
};

/**
 * Return the name of a file from the file path
 * @param {String} path
 */
export const filenameFromPath = path => {
    return path.split('\\').pop().split('/').pop();
};

export const isFileTypeAudio = file => {
    const mimeTypes = [
        'audio/midi',
        'audio/x-midi',
        'audio/mpeg',
        'audio/ogg',
        'audio/opus',
        'audio/wav',
        'audio/webm',
        'audio/3gpp',
        'audio/3gpp2'
    ];

    let type = file && typeof file === 'object' && 'type' in file ? file.type : file;
    return mimeTypes.includes(type);
};

export const isFileTypeWord = file => {
    const mimeTypes = ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];

    let type = file && typeof file === 'object' && 'type' in file ? file.type : file;
    return mimeTypes.includes(type);
};

export const isFileTypeVideo = file => {
    const mimeTypes = [
        'video/x-msvideo',
        'video/mp4',
        'video/mpeg',
        'video/ogg',
        'video/mp2t',
        'video/webm',
        'video/3gpp',
        'video/3gpp2'
    ];

    let type = file && typeof file === 'object' && 'type' in file ? file.type : file;
    return mimeTypes.includes(type);
};

export const isFileTypePdf = file => {
    const mimeTypes = ['application/pdf'];

    let type = file && typeof file === 'object' && 'type' in file ? file.type : file;
    return mimeTypes.includes(type);
};

export const isFileTypeCsv = file => {
    const mimeTypes = ['text/csv'];

    let type = file && typeof file === 'object' && 'type' in file ? file.type : file;
    return mimeTypes.includes(type);
};

export const isFileTypeExcel = file => {
    const mimeTypes = [
        'application/vnd.ms-excel',
        'application/vnd.ms-excel.sheet.macroEnabled.12',
        'application/vnd.ms-excel.template.macroEnabled.12',
        'application/vnd.ms-excel.addin.macroEnabled.12',
        'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ];

    let type = file && typeof file === 'object' && 'type' in file ? file.type : file;
    return mimeTypes.includes(type);
};

export const isFileTypeZip = file => {
    const mimeTypes = [
        'application/zip',
        'application/octet-stream',
        'application/x-zip-compressed',
        'multipart/x-zip',
        'application/x-7z-compressed'
    ];

    let type = file && typeof file === 'object' && 'type' in file ? file.type : file;
    return mimeTypes.includes(type);
};

export const isFileTypeImage = file => {
    const mimeTypes = [
        'image/avif',
        'image/bmp',
        'image/gif',
        'image/vnd.microsoft.icon',
        'image/jpeg',
        'image/png',
        'image/svg+xml',
        'image/tiff',
        'image/webp'
    ];

    let type = file && typeof file === 'object' && 'type' in file ? file.type : file;
    return mimeTypes.includes(type);
};

export const isFileTypeArchive = file => {
    const mimeTypes = [
        'application/zip',
        'application/octet-stream',
        'application/x-zip-compressed',
        'multipart/x-zip',
        'application/x-7z-compressed'
    ];

    let type = file && typeof file === 'object' && 'type' in file ? file.type : file;
    return mimeTypes.includes(type);
};

export const download = (url, download = false) => {
    const link = document.createElement('a');

    if (!url.startsWith('data') && !url.startsWith('http')) {
        url = `${config.API_BASE_URL}${url}`;
    }

    link.setAttribute('href', url);

    if (download) {
        link.setAttribute('download', download);
    }

    link.setAttribute('target', '_blank');

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

/**
 * Download an array as CSV
 * @param {Array} value
 * @param {String} name
 */
export const downloadArrayAsCsv = (value, name) => {
    const keys = Object.keys(value.find(item => item));

    let csv = keys.join(',') + '\n';

    for (const item of value) {
        const values = keys.map(k =>
            JSON.stringify(item[`${k}`], (k, v) => {
                if (v !== null) return v;
            })
        );
        csv += values.join(',') + '\n';
    }

    csv = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);

    download(csv, name);
};
